module.exports = __webpack_public_path__ + "assets/8fac322aa5cf17353ef1a51ffb7c9e57.mp3";